import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollRestoration component
 * Automatically scrolls to top when navigating to a new page or on initial load
 */
export const ScrollRestoration = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  // Also scroll to top on initial mount to prevent scroll restoration on refresh
  useEffect(() => {
    // Use setTimeout to ensure this runs after browser's scroll restoration
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return null;
};
